import { useTranslation } from 'react-i18next';

import { useAppDispatch, useAppSelector } from 'features/app/hooks';
import { useTrackedInteractionAction } from 'features/analytics/hooks';
import { useCaptionDisplayConfig } from 'features/call/call-captions/hooks';
import {
  selectCaptionsEnabled,
  toggleCaptionsThunk,
} from 'features/call/call-captions/store';
import { MenuIconButtonHorizontal } from 'features/menu/components';
import { isVrsModeSelector } from 'features/multi-mode/store';

export const CallCaptionsSettingsMenuButton = () => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const captionDisplayConfig = useCaptionDisplayConfig();
  const isVrs = useAppSelector(isVrsModeSelector);
  const captionsEnabled = useAppSelector(selectCaptionsEnabled);

  const { onActionClick } = useTrackedInteractionAction({
    actionName: 'captions-settings-toggle',
    methodName: 'handleCaptionsToggle',
    eventName: 'NavbarInteraction',
  });

  if (!captionDisplayConfig.enabled || !isVrs) {
    return null;
  }

  const handleCaptionsToggle = () => {
    dispatch(toggleCaptionsThunk());
    onActionClick();
  };

  return (
    <MenuIconButtonHorizontal
      testId='captions-settings-menu-button'
      title={captionsEnabled ? t('captionsOn') : t('captionsOff')}
      isDisabled={false}
      isChecked={captionsEnabled}
      isCheckIconVisible={captionsEnabled}
      onClickHandler={handleCaptionsToggle}
    />
  );
};
